import { render, staticRenderFns } from "./banner-content.vue?vue&type=template&id=40d2b1e7&scoped=true&"
import script from "./banner-content.vue?vue&type=script&lang=js&"
export * from "./banner-content.vue?vue&type=script&lang=js&"
import style0 from "./banner-content.vue?vue&type=style&index=0&id=40d2b1e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d2b1e7",
  null
  
)

export default component.exports